import { EditableReachTextEditor } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableReachTextEditor = styled(EditableReachTextEditor)``;
